export const notificationConfig = {
    method: 'POST',
    paths: ['/api/orgs/:orgId/locations/:locationId/kiosks/:kioskId/notify'],
    fields: {
        config: {
            type: 'object',
            fields: {
                expectsEthernet: {
                    type: 'bool',
                    displayName: 'Expects Ethernet',
                },
                kioskPrefix: {
                    type: 'keyString',
                    displayName: 'Kiosk Prefix',
                    validationRegex: '^[A-Z1-9]{1}$',
                },
                kioskPrinter: {
                    type: 'keyString',
                    displayName: 'Kiosk Printer',
                },
                menuMode: {
                    type: 'bool',
                    displayName: 'Load Menu Automatically',
                },
                willAcceptPayments: {
                    type: 'bool',
                    displayName: 'Will Accept Payments',
                },
            },
        },
    },
};
//# sourceMappingURL=kiosk_notification_config.js.map